import * as types from '../actionTypes/CreateAccountPostOrderActionTypes';

export default function CreateAccountPostOrderReducer(state = {}, action) {
    // NOSONAR
    const newState = { ...state };
    switch (action.type) {
        case types.CREATE_ACCOUNT_POST_REQUEST_SUCCESS:
            newState.data = action.createAccountPostOrderData.data || {};
            newState.data.accountRequestStatus = action.createAccountPostOrderData.status;
            return newState;
        case types.IS_EMAIL_ACCOUNT_EXIST:
            newState.checkAccountAPICalled = true;
            newState.isAccountExists = action.isAccountExists;
            return newState;
        case types.CHECK_ACCOUNT_API_CALLED:
            newState.checkAccountAPICalled = true;
            return newState;
        case types.CREATE_ACCOUNT_POST_REQUEST_ERROR:
            newState.data = action.createAccountPostOrderError.data || {};
            newState.data.accountRequestStatus = action.createAccountPostOrderError.status;
            return newState;
        case types.SET_ORDER_SOURCE:
            newState.orderSource = action.orderSource;
            return newState;
        case types.SET_XSESSIONID:
            newState.xSessionId = action.xSessionId;
            return newState;
        case types.ENROLL_REWARD_LINK_SUCCESS:
        case types.ENROLL_REWARD_LINK_ERROR:
            newState.data = action.enrollRewardsData.data || {};
            newState.data.accountRequestStatus = action.enrollRewardsData.status;
            return newState;
        default:
            return state;
    }
}
